import { entrypoint, viewOf, type PlaceFacts } from "../../client/index.ts";
import type { ThreadView } from "@nabla/api";
import { designCopy } from "../../design/copy.ts";

export const threadRequest = viewOf("conversa");

const place = (data: ThreadView): PlaceFacts => ({ title: designCopy.lugares.conversa, path: data.path, self: data.summary.anchor });

export const entrypoints = [entrypoint({
  id: "conversa",
  path: "/conversa/:c",
  level: "conversa",
  data: ({ c }) => threadRequest({ c }),
  view: () => import("./view.tsx"),
  place,
  morph: ({ c }) => `obj-${c}`,
})];
